import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {HelpTooltip} from '@/components/HelpTooltip';
import {TotalPriceOriginalContainer} from '@/components/PriceTag/components/DiscountedTotalPriceOriginal/components/TotalPriceOriginalContainer';

type Props = {
  isPlaceholder?: boolean;
};

export const Container = styled.div<Props>(
  ({theme, isPlaceholder}) => css`
    text-align: right;
    text-decoration: none;
    color: ${theme.colors.contentPrimary};

    ${isPlaceholder &&
    css`
      visibility: hidden;
    `}

    ${TotalPriceOriginalContainer} {
      margin-bottom: 2px;
    }

    ${HelpTooltip} {
      margin-top: 12px;
    }
  `
);
